import {TintReturn} from "./TintReturn.js"

export function GiftClickHandler(Passed,Pointer)
{
 
    const Scene = Passed.scene;
    Scene.IntitialCheck = true;
    //console.log(Scene.IntitialCheck);
    Scene.input.setDragState(Scene.input.activePointer,0);
    //Scene.input.setDragState(Pointer,1);

    Scene.AudioChan.Chan1.play('pick_up_ornament');

    let CopyOf;
    let Attachments = [];
    let AttachmentData = Passed.getData('Attachment');
    let DepthList = Scene.DepthList;
    let EndResult;

    if(TintReturn(Passed.tintTopLeft) === "0xffffff")
    {
        let PassedName = "Wt";
        let GiftX = 0;
        PassedName += Passed.frame.name;

        CopyOf = Scene.addImage(0,0,Passed.frame.name);

        //console.log(AttachmentData);
        
        let Cont = Scene.add.container(Pointer.x,Pointer.y,[CopyOf]);
        if(CopyOf.frame.name.includes("9"))GiftX = 5;

        Scene.addImage(GiftX,0,PassedName+"_Strk",Cont).setTint(0xD3CFE8);

        Cont.setSize(CopyOf.width, CopyOf.height);
        Cont.setDepth(DepthList.TreeItems);

        Cont.setInteractive();
        Scene.input.setDraggable(Cont);
        Scene.input._drag[0][0] = Cont;
        Scene.input._drag[1][0] = Cont;

        EndResult = Cont;
    }
    else
    {
        if(AttachmentData)
        {
            CopyOf = Scene.addImage(0,0,Passed.frame.name);
            CopyOf.setTint(TintReturn(Passed.tintTopLeft));

            //console.log(AttachmentData);
            
            let Cont = Scene.add.container(Pointer.x,Pointer.y,[CopyOf]);

            for (let x in AttachmentData)
            {
                Attachments[x] = Scene.addImage(AttachmentData[x][0],0 - AttachmentData[x][1],AttachmentData[x][2]);
                Cont.add(Attachments[x]);
            }

            Cont.setSize(CopyOf.width, CopyOf.height);
            Cont.setDepth(DepthList.TreeItems);

            Cont.setInteractive();
            Scene.input.setDraggable(Cont);
            Scene.input._drag[0][0] = Cont;
            Scene.input._drag[1][0] = Cont;
            

            EndResult = Cont;
        }

        else
        {
            CopyOf = Scene.addImage(Pointer.x,Pointer.y,Passed.frame.name);
            CopyOf.setTint(TintReturn(Passed.tintTopLeft));
            CopyOf.setInteractive();
            CopyOf.setDepth(DepthList.TreeItems);
            Scene.input.setDraggable(CopyOf);
            Scene.input._drag[1][0] = CopyOf;
            Scene.input._drag[0][0] = CopyOf;
            EndResult = CopyOf;
        }
    }

        Scene.InitialCheck = true;

        EndResult.setDepth(DepthList.GiftsForward)

        Scene.DragObject = EndResult;

        Scene.input.setDragState(Pointer,4);
    
}